import * as S from './styles';

export type LogoProps = {
  color?: 'secondary' | 'primary';
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'full';
  variants: 'vertical' | 'horizontal' | 'icon';
};

export const Logo = ({
  color = 'primary',
  size = 'medium',
  variants
}: LogoProps) => (
  <S.Wrapper color={color} size={size}>
    {variants === 'icon' && (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
      >
        <path
          d="M15.9621 32C12.6015 32 9.34205 30.939 6.56264 28.918C3.10102 26.3918 0.852225 22.6783 0.195274 18.4596C-0.461677 14.2409 0.549015 10.0221 3.07575 6.56124C5.60248 3.10035 9.31678 0.852041 13.5364 0.195231C17.7561 -0.461579 21.9757 0.548901 25.4374 3.07509C28.899 5.60129 31.1478 9.31479 31.8047 13.5335C32.4617 17.7523 31.451 21.971 28.9242 25.4319C26.3975 28.8928 22.6832 31.1411 18.4636 31.7979C17.6297 31.9495 16.7959 32 15.9621 32ZM16.0379 0.523637C15.2293 0.523637 14.4208 0.57416 13.6122 0.70047C9.51893 1.33202 5.93096 3.52981 3.5053 6.86438C1.07963 10.199 0.0689385 14.2914 0.72589 18.3838C1.35757 22.4763 3.55583 26.0634 6.89112 28.4886C10.2264 30.9137 14.3197 31.9242 18.413 31.2674C22.5063 30.6359 26.0943 28.4381 28.52 25.1035C30.9456 21.7689 31.9563 17.6765 31.2994 13.5841C30.6677 9.49162 28.4694 5.90443 25.1341 3.47928C22.4558 1.55938 19.2974 0.523637 16.0379 0.523637Z"
          fill="url(#paint0_linear_2929:16638)"
        ></path>
        <path
          d="M11.9193 30.7117C10.2011 30.7117 8.58401 30.2823 7.19431 29.3476C2.03977 25.9372 1.81236 17.1713 6.6637 9.82009C9.01356 6.25816 12.172 3.55513 15.6083 2.21624C19.0447 0.852101 22.3295 1.00367 24.8562 2.67096C30.0107 6.08132 30.2381 14.8472 25.3868 22.1984C21.7988 27.554 16.518 30.7117 11.9193 30.7117ZM6.8911 9.97166L7.1185 10.1232C2.41878 17.2471 2.57038 25.6846 7.49751 28.9181C12.3994 32.1769 20.2323 29.0192 24.932 21.8953C29.6317 14.7714 29.4801 6.33394 24.553 3.10041C22.1778 1.53417 19.07 1.40787 15.7852 2.69622C12.4752 4.00984 9.39257 6.63708 7.09324 10.1232L6.8911 9.97166Z"
          fill="url(#paint1_linear_2929:16638)"
        ></path>
        <path
          d="M21.723 30.3076C20.2323 30.3076 18.5646 29.7518 16.7706 28.6908C13.8902 26.9477 11.0855 23.9921 8.88722 20.3796C4.31383 12.8768 3.78322 4.81829 7.69966 2.4184C9.61998 1.23109 12.3236 1.5595 15.2546 3.35309C18.1351 5.09617 20.9397 8.05182 23.138 11.6643C27.7114 19.1671 28.242 27.2256 24.3256 29.6255C23.5676 30.0802 22.6832 30.3076 21.723 30.3076ZM10.3022 2.24157C9.44311 2.24157 8.65982 2.44367 7.9776 2.87312C4.28857 5.12143 4.89498 12.8516 9.34204 20.1018C11.515 23.6384 14.2439 26.5183 17.0486 28.2361C19.8027 29.9034 22.3042 30.2318 24.0476 29.1708C27.7367 26.9225 27.1303 19.1923 22.6832 11.9422C20.5102 8.40548 17.7813 5.52562 14.9767 3.80781C13.2837 2.77207 11.6919 2.24157 10.3022 2.24157Z"
          fill="url(#paint2_linear_2929:16638)"
        ></path>
        <path
          d="M23.4412 26.7959C23.2138 26.7959 22.9612 26.7959 22.7338 26.7707C19.3732 26.6191 15.482 25.356 11.8183 23.2593C4.21278 18.8637 -0.107936 12.043 2.19139 8.05157C4.49072 4.06019 12.551 4.38859 20.1817 8.78417C23.8455 10.9062 26.8523 13.6345 28.6968 16.4638C30.5414 19.3437 30.9456 22.0214 29.8086 23.9918C28.7474 25.8107 26.5239 26.7959 23.4412 26.7959ZM8.55877 5.75274C5.80463 5.75274 3.63163 6.58638 2.64621 8.30419C0.498482 12.043 4.71813 18.5353 12.0709 22.7793C15.6589 24.8508 19.449 26.0886 22.7338 26.2402C25.968 26.3917 28.2926 25.4823 29.3285 23.714C30.3645 21.9204 29.9602 19.4447 28.2168 16.7417C26.448 13.9629 23.4918 11.3104 19.9038 9.23888C15.9368 6.91479 11.8435 5.75274 8.55877 5.75274Z"
          fill="url(#paint3_linear_2929:16638)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_2929:16638"
            x1="28.466"
            y1="5.98222"
            x2="3.54897"
            y2="26.0751"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0139441" stopOpacity="0"></stop>
            <stop offset="0.2978" stopColor="#F05824"></stop>
            <stop offset="0.9247" stopColor="#FF4800"></stop>
          </linearGradient>
          <linearGradient
            id="paint1_linear_2929:16638"
            x1="28.8573"
            y1="16.0045"
            x2="3.15835"
            y2="16.0045"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0"></stop>
            <stop offset="0.2389" stopColor="#F05824"></stop>
            <stop offset="0.5812" stopColor="#FF4800"></stop>
          </linearGradient>
          <linearGradient
            id="paint2_linear_2929:16638"
            x1="3.39858"
            y1="8.73204"
            x2="28.6144"
            y2="23.2935"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.361" stopOpacity="0"></stop>
            <stop offset="0.4125" stopOpacity="0"></stop>
            <stop offset="1" stopColor="#F05824"></stop>
          </linearGradient>
          <linearGradient
            id="paint3_linear_2929:16638"
            x1="9.42394"
            y1="22.3697"
            x2="22.6003"
            y2="9.64265"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0315461" stopOpacity="0"></stop>
            <stop offset="0.1869" stopColor="#F05824"></stop>
            <stop offset="1" stopColor="#FF4800"></stop>
          </linearGradient>
        </defs>
      </svg>
    )}

    {variants === 'horizontal' && (
      <svg
        role="img"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 452 133"
      >
        <path
          d="M148.596 65.585c0-12.889 9.915-23.26 22.635-23.26 9.415 0 17.127 5.84 20.633 14.298l-3.506 1.007c-2.804-6.847-9.114-11.78-17.027-11.78-10.917-.101-18.929 8.659-18.929 19.735 0 10.673 7.912 19.634 18.929 19.634 8.013 0 14.223-4.732 17.027-11.68l3.506 1.007c-3.306 8.256-11.018 14.298-20.633 14.298-12.82-.1-22.635-10.572-22.635-23.26ZM198.073 43.232h3.506v45.41h-3.506v-45.41ZM207.989 71.324c0-9.767 7.712-17.721 17.527-17.721 9.115 0 16.126 7.048 17.127 15.808.201 1.208.201 2.316.1 3.222h-31.148c.4 7.753 6.61 13.19 13.921 13.19 5.209 0 9.816-2.718 12.32-6.847l3.405.604c-2.804 5.74-9.014 9.566-15.725 9.566-9.915 0-17.527-7.955-17.527-17.822Zm31.049-1.611c-.601-7.048-6.31-12.788-13.722-12.788-7.512 0-13.221 5.74-13.922 12.788h27.644ZM246.75 79.379c-.201-5.538 3.505-11.076 15.524-11.076l11.618-.1v-3.021c0-5.74-5.408-8.458-11.518-8.458-4.807 0-10.015 1.611-10.917 6.746l-3.505.1c.601-6.645 7.011-9.968 14.322-9.968 8.313 0 15.024 4.23 15.024 11.076v23.864h-3.406V79.58c-1.001 2.216-5.108 9.465-14.723 9.465-6.71.1-12.119-3.323-12.419-9.666Zm27.142-8.257h-11.217c-10.116.101-12.72 4.632-12.42 8.257.401 4.229 4.407 6.545 9.014 6.545 7.913 0 14.623-6.646 14.623-14.802ZM284.108 54.207h3.506v7.753c2.103-5.94 7.512-9.062 14.823-7.955v3.726c-8.413-1.813-14.823 3.423-14.823 13.593v17.218h-3.506V54.207ZM306.744 81.896v-4.128c5.709 5.135 12.419 7.854 18.529 7.854 6.11 0 12.019-2.82 12.019-8.76 0-5.034-4.207-7.552-12.72-9.465-10.316-2.416-17.728-4.43-17.728-12.485 0-8.257 8.313-12.284 16.426-12.284 7.011 0 12.82 2.718 16.426 5.84v4.128c-4.107-3.826-10.116-6.646-16.426-6.646-6.31 0-12.92 2.92-12.92 9.062 0 5.337 6.109 7.049 14.022 8.861 10.817 2.417 16.325 5.74 16.425 12.888 0 8.458-7.311 12.385-15.724 12.385-7.412 0-13.221-3.121-18.329-7.25ZM345.805 79.379c-.2-5.538 3.506-11.076 15.525-11.076l11.618-.1v-3.021c0-5.74-5.409-8.458-11.518-8.458-4.808 0-10.016 1.611-10.917 6.746l-3.506.1c.601-6.645 7.011-9.968 14.323-9.968 8.313 0 15.023 4.23 15.023 11.076v23.864h-3.405V79.58c-1.002 2.216-5.108 9.465-14.723 9.465-6.611.1-12.119-3.323-12.42-9.666Zm27.143-8.257H361.73c-10.116.101-12.72 4.632-12.419 8.257.4 4.229 4.407 6.545 9.014 6.545 7.912 0 14.623-6.646 14.623-14.802ZM383.364 43.232h3.506v45.41h-3.506v-45.41ZM393.18 71.324c0-9.767 7.712-17.721 17.527-17.721 9.114 0 16.125 7.048 17.127 15.808.2 1.208.2 2.316.1 3.222h-31.149c.401 7.753 6.611 13.19 13.922 13.19 5.208 0 9.815-2.718 12.319-6.847l3.406.604c-2.805 5.74-9.014 9.566-15.725 9.566-9.915 0-17.527-7.955-17.527-17.822Zm31.148-1.611c-.6-7.048-6.309-12.788-13.721-12.788-7.512 0-13.221 5.74-13.922 12.788h27.643Z"
          fill="currentColor"
        />
        <path
          d="M66.166 109c-8.877 0-17.488-2.818-24.83-8.186-9.144-6.71-15.085-16.575-16.82-27.78-1.736-11.207.934-22.413 7.609-31.606 6.675-9.193 16.487-15.165 27.633-16.91 11.147-1.744 22.294.94 31.438 7.65 9.145 6.71 15.085 16.574 16.821 27.78 1.735 11.206-.935 22.413-7.609 31.605-6.675 9.193-16.487 15.166-27.634 16.91-2.202.403-4.405.537-6.608.537Zm.2-83.61c-2.135 0-4.271.135-6.407.47-10.813 1.678-20.292 7.516-26.7 16.373-6.407 8.858-9.077 19.729-7.341 30.599 1.668 10.87 7.475 20.399 16.286 26.84 8.81 6.443 19.624 9.127 30.437 7.382 10.813-1.677 20.291-7.515 26.699-16.373 6.407-8.857 9.077-19.728 7.342-30.598-1.669-10.87-7.476-20.4-16.286-26.841-7.076-5.1-15.42-7.851-24.03-7.851Z"
          fill="currentColor"
        />
        <path
          d="M55.487 105.578c-4.54 0-8.811-1.141-12.482-3.624-13.617-9.058-14.217-32.343-1.402-51.87 6.208-9.46 14.551-16.64 23.629-20.197 9.078-3.624 17.755-3.221 24.43 1.208 13.616 9.058 14.217 32.343 1.401 51.87-9.478 14.225-23.428 22.613-35.576 22.613Zm-13.283-55.09.6.402C30.39 69.812 30.79 92.225 43.807 100.814c12.949 8.656 33.64.268 46.056-18.655 12.415-18.923 12.014-41.335-1.002-49.924-6.274-4.16-14.484-4.495-23.16-1.073C56.954 34.65 48.811 41.63 42.737 50.89l-.534-.403Z"
          fill="currentColor"
        />
        <path
          d="M81.385 104.504c-3.938 0-8.344-1.476-13.083-4.294-7.609-4.63-15.018-12.481-20.825-22.077-12.081-19.93-13.483-41.335-3.137-47.71 5.073-3.153 12.215-2.281 19.957 2.483 7.61 4.63 15.019 12.481 20.826 22.077 12.08 19.93 13.483 41.335 3.137 47.709-2.003 1.208-4.339 1.812-6.875 1.812Zm-30.17-74.55c-2.27 0-4.339.537-6.141 1.677-9.745 5.972-8.143 26.506 3.604 45.764 5.74 9.394 12.95 17.044 20.358 21.607 7.276 4.428 13.884 5.301 18.49 2.483 9.745-5.973 8.143-26.506-3.605-45.764-5.74-9.394-12.949-17.044-20.358-21.607-4.472-2.751-8.677-4.16-12.348-4.16Z"
          fill="currentColor"
        />
        <path
          d="M85.924 95.177c-.601 0-1.269 0-1.87-.067-8.877-.403-19.156-3.758-28.834-9.327-20.091-11.676-31.505-29.794-25.431-40.396 6.074-10.602 27.366-9.73 47.524 1.946 9.678 5.637 17.621 12.884 22.494 20.4 4.873 7.649 5.941 14.762 2.937 19.996-2.803 4.831-8.677 7.448-16.82 7.448ZM46.609 39.281c-7.275 0-13.015 2.214-15.619 6.777-5.673 9.931 5.474 27.177 24.897 38.45 9.478 5.502 19.49 8.79 28.168 9.193 8.543.402 14.684-2.013 17.421-6.71 2.736-4.765 1.668-11.34-2.937-18.52-4.672-7.382-12.482-14.428-21.96-19.93-10.48-6.173-21.292-9.26-29.97-9.26Z"
          fill="currentColor"
        />
        <defs>
          <linearGradient
            id="a"
            x1="99.197"
            y1="39.89"
            x2="33.09"
            y2="92.906"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".014" stopOpacity="0" />
            <stop offset=".298" stopColor="#F05824" />
            <stop offset=".925" stopColor="#FF4800" />
          </linearGradient>
          <linearGradient
            id="b"
            x1="100.231"
            y1="66.512"
            x2="32.343"
            y2="66.512"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset=".239" stopColor="#F05824" />
            <stop offset=".581" stopColor="#FF4800" />
          </linearGradient>
          <linearGradient
            id="c"
            x1="32.978"
            y1="47.194"
            x2="99.772"
            y2="85.554"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".361" stopOpacity="0" />
            <stop offset=".412" stopOpacity="0" />
            <stop offset="1" stopColor="#F05824" />
          </linearGradient>
          <linearGradient
            id="d"
            x1="48.895"
            y1="83.42"
            x2="83.887"
            y2="49.806"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".032" stopOpacity="0" />
            <stop offset=".187" stopColor="#F05824" />
            <stop offset="1" stopColor="#FF4800" />
          </linearGradient>
        </defs>
      </svg>
    )}

    {variants === 'vertical' && (
      <svg
        role="img"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 236 258"
      >
        <path
          d="M119.271 158.56c-13.388 0-26.373-4.196-37.445-12.189-13.79-9.991-22.749-24.678-25.366-41.363-2.617-16.685 1.41-33.37 11.475-47.058 10.066-13.688 24.863-22.58 41.673-25.178 16.81-2.598 33.62 1.399 47.41 11.39s22.749 24.678 25.366 41.363c2.617 16.685-1.41 33.37-11.475 47.058-10.066 13.688-24.863 22.58-41.673 25.178-3.322.599-6.643.799-9.965.799Zm.302-124.489c-3.221 0-6.442.2-9.663.7-16.307 2.497-30.6 11.19-40.264 24.378-9.663 13.188-13.69 29.373-11.072 45.559 2.516 16.186 11.274 30.373 24.56 39.964 13.287 9.592 29.594 13.588 45.901 10.991 16.306-2.498 30.6-11.19 40.263-24.379 9.663-13.188 13.69-29.373 11.072-45.56-2.516-16.185-11.273-30.372-24.56-39.963-10.67-7.594-23.252-11.69-36.237-11.69Z"
          fill="currentColor"
        />
        <path
          d="M103.165 153.465c-6.844 0-13.287-1.699-18.823-5.396-20.534-13.488-21.44-48.157-2.114-77.23 9.362-14.088 21.944-24.779 35.634-30.074 13.689-5.395 26.775-4.796 36.841 1.798 20.534 13.488 21.44 48.157 2.113 77.232-14.293 21.181-35.331 33.67-53.651 33.67Zm-20.03-82.027.905.6c-18.722 28.174-18.118 61.544 1.51 74.333 19.528 12.888 50.732.4 69.454-27.775 18.723-28.175 18.119-61.546-1.509-74.334-9.462-6.195-21.843-6.694-34.929-1.599C105.38 47.86 93.1 58.25 83.94 72.037l-.806-.6Z"
          fill="currentColor"
        />
        <path
          d="M142.221 151.866c-5.939 0-12.582-2.198-19.729-6.394-11.475-6.894-22.648-18.584-31.406-32.871-18.219-29.674-20.332-61.545-4.73-71.037 7.65-4.695 18.42-3.397 30.096 3.697 11.475 6.894 22.649 18.583 31.406 32.87 18.219 29.674 20.333 61.546 4.731 71.038-3.02 1.798-6.543 2.697-10.368 2.697ZM96.723 40.865c-3.422 0-6.542.8-9.26 2.498-14.696 8.892-12.28 39.465 5.435 68.139 8.657 13.988 19.528 25.377 30.701 32.171 10.972 6.595 20.937 7.893 27.883 3.697 14.696-8.892 12.28-39.465-5.436-68.14-8.657-13.987-19.528-25.377-30.701-32.17-6.744-4.097-13.085-6.195-18.622-6.195Z"
          fill="currentColor"
        />
        <path
          d="M149.066 137.978c-.906 0-1.913 0-2.819-.1-13.387-.599-28.889-5.595-43.484-13.887-30.298-17.385-47.51-44.36-38.351-60.147 9.16-15.785 41.27-14.487 71.669 2.898 14.595 8.392 26.574 19.183 33.922 30.373 7.348 11.39 8.958 21.98 4.429 29.773-4.228 7.194-13.086 11.09-25.366 11.09ZM89.778 54.752c-10.972 0-19.628 3.298-23.554 10.092-8.556 14.786 8.254 40.463 37.545 57.248 14.294 8.193 29.393 13.089 42.478 13.688 12.885.6 22.145-2.997 26.272-9.991 4.127-7.094 2.517-16.885-4.429-27.575-7.046-10.99-18.823-21.481-33.116-29.674-15.804-9.192-32.11-13.788-45.196-13.788Z"
          fill="currentColor"
        />
        <path
          d="M32 211.513c0-7.793 6.14-14.087 13.992-14.087 5.838 0 10.569 3.596 12.683 8.692l-2.215.599c-1.711-4.196-5.637-7.093-10.468-7.093-6.745 0-11.677 5.295-11.677 11.989 0 6.494 4.932 11.889 11.677 11.889 4.932 0 8.757-2.897 10.468-7.093l2.215.599c-2.014 5.096-6.745 8.692-12.683 8.692C38.038 225.6 32 219.306 32 211.513ZM62.399 197.926h2.214v27.575H62.4v-27.575ZM68.539 215.01c0-5.995 4.73-10.791 10.77-10.791 5.637 0 9.966 4.297 10.57 9.592.1.699.1 1.399 0 1.898H70.752c.302 4.696 4.027 8.093 8.556 8.093 3.222 0 6.04-1.698 7.55-4.196l2.114.399c-1.712 3.497-5.537 5.795-9.664 5.795-6.14.1-10.77-4.795-10.77-10.79Zm19.125-.999c-.403-4.296-3.825-7.793-8.455-7.793s-8.154 3.497-8.556 7.793h17.011ZM92.395 219.905c-.1-3.397 2.215-6.694 9.563-6.793h7.146v-1.799c0-3.497-3.321-5.095-7.146-5.095-2.92 0-6.14.999-6.745 4.096H93.1c.402-4.096 4.328-5.995 8.858-5.995 5.133 0 9.26 2.598 9.26 6.794V225.6h-2.114v-5.395c-.604 1.299-3.12 5.795-9.059 5.795-4.127-.1-7.449-2.198-7.65-6.095Zm16.709-4.995h-6.844c-6.241 0-7.852 2.797-7.65 5.095.2 2.598 2.717 3.997 5.536 3.997 4.831-.1 8.958-4.097 8.958-9.092ZM115.446 204.619h2.214v4.696c1.309-3.597 4.631-5.495 9.16-4.796v2.298c-5.133-1.099-9.16 2.098-9.16 8.293v10.49h-2.214v-20.981ZM129.337 221.504v-2.498c3.523 3.098 7.65 4.796 11.374 4.796s7.449-1.698 7.449-5.295c0-2.997-2.617-4.596-7.852-5.795-6.341-1.499-10.971-2.698-10.971-7.593 0-5.096 5.133-7.494 10.166-7.494 4.328 0 7.852 1.699 10.167 3.597v2.498c-2.517-2.298-6.241-3.996-10.167-3.996s-7.952 1.798-7.952 5.495c0 3.297 3.725 4.296 8.657 5.395 6.643 1.499 10.066 3.497 10.066 7.893 0 5.095-4.53 7.493-9.664 7.493-4.529-.1-8.153-1.998-11.273-4.496ZM153.394 219.905c-.101-3.397 2.214-6.694 9.563-6.793h7.146v-1.799c0-3.497-3.321-5.095-7.146-5.095-2.92 0-6.141.999-6.745 4.096h-2.113c.402-4.096 4.328-5.995 8.858-5.995 5.133 0 9.26 2.598 9.26 6.794V225.6h-2.114v-5.395c-.604 1.299-3.12 5.795-9.059 5.795-4.127-.1-7.449-2.198-7.65-6.095Zm16.709-4.995h-6.844c-6.241 0-7.852 2.797-7.651 5.095.202 2.598 2.718 3.997 5.537 3.997 4.831-.1 8.958-4.097 8.958-9.092ZM176.445 197.926h2.214v27.575h-2.214v-27.575ZM182.585 215.01c0-5.995 4.731-10.791 10.77-10.791 5.637 0 9.966 4.297 10.57 9.592.1.699.1 1.399 0 1.898h-19.126c.302 4.696 4.027 8.093 8.556 8.093 3.221 0 6.04-1.698 7.55-4.196l2.114.399c-1.712 3.497-5.537 5.795-9.664 5.795-6.14.1-10.77-4.795-10.77-10.79Zm19.125-.999c-.403-4.296-3.825-7.793-8.455-7.793-4.631 0-8.154 3.497-8.556 7.793h17.011Z"
          fill="currentColor"
        />
        <defs>
          <linearGradient
            id="a"
            x1="169.083"
            y1="55.66"
            x2="70.387"
            y2="135.825"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".014" stopOpacity="0" />
            <stop offset=".298" stopColor="#F05824" />
            <stop offset=".925" stopColor="#FF4800" />
          </linearGradient>
          <linearGradient
            id="b"
            x1="170.642"
            y1="95.298"
            x2="68.264"
            y2="95.298"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset=".239" stopColor="#F05824" />
            <stop offset=".581" stopColor="#FF4800" />
          </linearGradient>
          <linearGradient
            id="c"
            x1="69.221"
            y1="66.535"
            x2="169.309"
            y2="124.753"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".361" stopOpacity="0" />
            <stop offset=".412" stopOpacity="0" />
            <stop offset="1" stopColor="#F05824" />
          </linearGradient>
          <linearGradient
            id="d"
            x1="93.225"
            y1="120.472"
            x2="145.349"
            y2="69.76"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".032" stopOpacity="0" />
            <stop offset=".187" stopColor="#F05824" />
            <stop offset="1" stopColor="#FF4800" />
          </linearGradient>
        </defs>
      </svg>
    )}
  </S.Wrapper>
);
